module.exports = __webpack_public_path__ + "img/max-file-repeat--excel.55e3b0d2.svg";